"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonCell = exports.PersonCellPhotoSizes = exports.PersonCellFontSizes = exports.PersonCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var person_photo_1 = require("./person-photo");
var location_label_1 = require("./location-label");
var entity_link_1 = require("./entity-link");
var cell_1 = require("../elements/cell");
var entity_menu_1 = require("./entity-menu");
exports.PersonCellDefaultProps = {
  showLocation: false,
  showOrganisation: false,
  linkPerson: true,
  size: 'default'
};
exports.PersonCellFontSizes = {
  default: 13,
  large: 15
};
exports.PersonCellPhotoSizes = {
  default: 56,
  large: 80
};
// -------- Styles -------->
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    line-height: 1.1em;\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    line-height: 1.1em;\n\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme_1.theme.FONT_SIZE(exports.PersonCellFontSizes[size]));
  })
});
var PersonPhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 500;\n  "], ["\n    color: ", ";\n    font-weight: 500;\n  "])), theme_1.theme.COLOR('dark'))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    padding-top: ", ";\n    font-size: 1em;\n  "], ["\n    color: ", ";\n    padding-top: ", ";\n    font-size: 1em;\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.UNIT(1))
});
var InfoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-weight: 500;\n  "], ["\n    font-weight: 500;\n  "])))
});
// -------- Components -------->
var My = {
  Container: cell_1.Cell,
  Body: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Photo: (0, styled_components_1.default)(person_photo_1.PersonPhoto)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), PersonPhotoStyles),
  Link: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Name: styled_components_1.default.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  LocationLabel: (0, styled_components_1.default)(location_label_1.LocationLabel)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  OrganisationLabel: styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  PositionLabel: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Info: styled_components_1.default.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles)
};
var PersonCell = function (props) {
  var className = props.className,
    entity = props.entity,
    showLocation = props.showLocation,
    showOrganisation = props.showOrganisation,
    showPosition = props.showPosition,
    linkPerson = props.linkPerson,
    size = props.size;
  return react_1.default.createElement(My.Container, __assign({}, props, {
    menu: react_1.default.createElement(entity_menu_1.EntityMenu, {
      entity: entity
    })
  }), react_1.default.createElement(My.Body, {
    size: size
  }, react_1.default.createElement(My.Photo, {
    link: linkPerson,
    size: exports.PersonCellPhotoSizes[size],
    entity: entity
  }), react_1.default.createElement(My.Info, null, linkPerson ? react_1.default.createElement(My.Link, {
    entity: entity
  }) : react_1.default.createElement(My.Name, null, entity.name), showPosition && entity.position && react_1.default.createElement(My.PositionLabel, null, entity.position), showOrganisation && entity.organisation && react_1.default.createElement(My.OrganisationLabel, null, entity.organisation.name), showLocation && entity.location && react_1.default.createElement(My.LocationLabel, {
    entity: entity.location
  }))));
};
exports.PersonCell = PersonCell;
exports.PersonCell.defaultProps = exports.PersonCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;